import React from "react";

function UpArrow({ width = 19 }: { width?: number }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height="12"
            fill="none"
            viewBox="0 0 19 12"
            className="rtl:rotate-180"
        >
            <path
                fill="#000"
                fillRule="evenodd"
                d="M18.82 9.91L16.84 12 9.429 4.18 2.017 12 .037 9.91 9.429 0l9.391 9.91z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default UpArrow;
